import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom";
import "./index.css";
import Header from "./components/Header.js";
import Form from "./components/Form.js";
import Board from "./components/Board.js";
import Footer from "./components/Footer.js";

// import i18n (needs to be bundled ;))
import "./i18n";

function App() {
  const [name, setName] = useState(localStorage.getItem("name") || "Stranger");
  const [birthday, setBirthday] = useState(
    localStorage.getItem("birthday") || new Date("2000-01-01")
  );
  const [expected, setExpected] = useState(
    localStorage.getItem("expected") || 80
  );
  const [registered, setRegistered] = useState(
    localStorage.getItem("registered") || false
  );
  const [view, setView] = useState(localStorage.getItem("view") || "years");

  useEffect(() => {
    document.title = "Life In Blocks";
  }, []);

  useEffect(() => {
    localStorage.setItem("name", name);
  }, [name]);
  useEffect(() => {
    localStorage.setItem("birthday", birthday);
  }, [birthday]);
  useEffect(() => {
    localStorage.setItem("expected", expected);
  }, [expected]);
  useEffect(() => {
    localStorage.setItem("registered", true);
  }, [registered]);
  useEffect(() => {
    localStorage.setItem("view", view);
  }, [view]);

  return (
    <div className="p-6 max-w-xl mx-auto space-y-6 font-sans">
      <Header
        name={name}
        registered={registered}
        view={view}
        setView={setView}
      />
      <Form
        name={name}
        setName={setName}
        birthday={birthday}
        setBirthday={setBirthday}
        expected={expected}
        setExpected={setExpected}
        registered={registered}
        setRegistered={setRegistered}
      />
      <Board view={view} birthday={birthday} expected={expected} />
      <Footer registered={registered} setRegistered={setRegistered} />
    </div>
  );
}

ReactDOM.render(<App />, document.getElementById("root"));
